import React, { useState, useEffect, useRef } from 'react';
import '../styles/global.css'; // Crie este arquivo CSS
import { useNavigate, Link } from 'react-router-dom';
import logo_mgbe from '../assets/logo_mgbe.png';
import { PrivacyTip } from '@mui/icons-material';
import CookieBanner from '../pages/CookieBanner';

// Definindo o tipo de usuário para teste
// Altere para "visitante", "admin" ou "associado" para testar
//sessionStorage.tipoUsuario = "visitante";
//sessionStorage.tipoUsuario = "associado";
//sessionStorage.tipoUsuario = "admin"; // visitante, admin, associado

const Header = () => {
  const [menuAberto, setMenuAberto] = useState(false);
  const loggedIn = sessionStorage.loggedIn;
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuAberto(!menuAberto);
  };

  function handleEditPessoa(){
    const pessoaJSON = JSON.parse(sessionStorage.userStr);
    sessionStorage.setItem('origemEditarPessoa', 'Header');
    //console.log(pessoaJSON);
    navigate(`/Cadastro`, { state: { cadastro: pessoaJSON } });
    //window.location.reload();
  }

  const toggleLogoff = () => {
    localStorage.clear();
    localStorage.setItem('loggedIn', false);
    localStorage.removeItem('user');
    sessionStorage.clear();
    
    navigate('/');
    window.location.reload();
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuAberto(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef]);

//console.log(loggedIn);
  return (
    <header>
      <nav className="navbar">
        <div className="nav-logo">
            <img src={logo_mgbe} alt="Logo MGBE" className="logo" />
        </div>
        <div className='divLabelHeader'>
            <label className='labelHeader' >M.G.BRASIL EXTREMOS</label>
        </div>
        <div className={`nav-links ${menuAberto ? 'aberto' : ''}`} ref={menuRef}>
          
          <Link to="/AvisoLegal" onClick={toggleMenu}><PrivacyTip /></Link>
          <Link to="/" onClick={toggleMenu}>MGBE</Link>
          <Link to="/AcaoSocial" onClick={toggleMenu}>Ação Social</Link>
          <Link to="/Sobre" onClick={toggleMenu}>Sobre</Link>
          <Link to="/Eventos" onClick={toggleMenu}>Eventos</Link>
          <Link to="/Contato/0" onClick={toggleMenu}>Contato</Link>
          
          {
            sessionStorage.loggedIn === 'true' ? (
              <Link to="/AreaDoAssociado" onClick={toggleMenu}>Área do Associado</Link>
            ) : (
              <Link to="/Login" onClick={toggleMenu}>Login</Link>
            )
          }

          <label>
            {
              sessionStorage.apelidoUsuario !== undefined 
              && sessionStorage.apelidoUsuario !== '' 
              ? <span className='link' style={{ cursor: 'pointer' }} onClick={handleEditPessoa}>{'[ ' + sessionStorage.apelidoUsuario + ' ]'}</span> 
              : ''}
          </label>

          {sessionStorage.loggedIn === 'true' ? (
            <Link to="/" onClick={toggleLogoff}>SAIR</Link>
          ) : ('')}
          
        </div>
        <div>
          <button className="menu-toggle" style={{ textDecoration: 'none' }} onClick={toggleMenu}>
            <img src={logo_mgbe} alt="Logo MGBE" className="logoMenu" style={{ textDecoration: 'none' }}  />
          </button>
          <span className='text-align-right LnkMenu'>MENU</span>
        </div>
      </nav>
      <CookieBanner />
    </header>
  );
  
};

export default Header;